import { render, staticRenderFns } from "./SortInput.vue?vue&type=template&id=149ea203&scoped=true"
import script from "./SortInput.vue?vue&type=script&lang=js"
export * from "./SortInput.vue?vue&type=script&lang=js"
import style0 from "./SortInput.vue?vue&type=style&index=0&id=149ea203&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149ea203",
  null
  
)

export default component.exports